/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSubjects.defs.js'
export { main as default } from './getSubjects.defs.js'
